firebird.factory('peerConnectionService', [
    '$rootScope',
    '$q',
    '$window',
    '$timeout',
    'vertoService',
    'socketService',
    'logService',
    'helperService',
    'attendeeService',
    'storageService',
    'analyticsWrapperService',
    'localStreamManagerService',
    function (
        $rootScope,
        $q,
        $window,
        $timeout,
        vertoService,
        socketService,
        logService,
        helperService,
        attendeeService,
        storageService,
        analyticsWrapperService,
        localStreamManagerService
    ) {
        const logger = logService.createLoggerWithSource('peerConnectionService');

        var peerConnection = null;
        var inActiveConnection = false;
        var iceServers;
        var offerOptions = {
            offerToReceiveAudio: 0,
            offerToReceiveVideo: 1
        };

        var remoteStream = null;

        var advancedConfig = {
            optional: [
                { googCpuOveruseDetection: true },
                { googCpuUnderuseThreshold: 55 },
                { googCpuOveruseThreshold: 85 },
                { googCpuOveruseEncodeUsage: true },
                { googScreencastMinBitrate: 500 },
                { googHighStartBitrate: true },
                { googPayloadPadding: true }
            ]
        };

        var service = {
            init: init,
            getPeerConnection: getPeerConnection,
            setPeerConnection: setPeerConnection,
            initiatePeerConnectionFlow: initiatePeerConnectionFlow,
            destroyPeerConnection: destroyPeerConnection,
            onNewTrack: onNewTrack,
            onICEConnectionStateChange: onICEConnectionStateChange,
            getPeerConnectionVideoSender: getPeerConnectionVideoSender,
            isPeerConnectionVideoTrackActive: isPeerConnectionVideoTrackActive,
            getRemoteStream: getRemoteStream
        };

        $rootScope.$on('offer-created', onRemoteOffer);
        $rootScope.$on('answer-created', onRemoteAnswer);
        $rootScope.$on('new-ice-candidate', onNewRemoteIceCandidate);
        $rootScope.$on('destroy-pip-peer', onDestroyPIPPeer);

        return service;

        ////////////////////////

        function getPeerConnection() {
            return peerConnection;
        }

        function setPeerConnection(pc) {
            peerConnection = pc;
        }

        function init() {
            iceServers = vertoService.getIceServers();
            if (peerConnection) {
                service.destroyPeerConnection();
            }
            peerConnection = new $window.RTCPeerConnection({ iceServers: iceServers }, advancedConfig);
            peerConnection.onicecandidate = onNewLocalIceCandidate;
            peerConnection.ontrack = onNewTrack;
            peerConnection.oniceconnectionstatechange = onICEConnectionStateChange;
        }

        function getPeerConnectionVideoSender() {
            try {
                var videoSender = null;
                var peer = service.getPeerConnection();

                if (peer && peer.getSenders) {
                    var senders = peer.getSenders(); //Should have one sender each for Audio and Video

                    for (var i = 0; i < senders.length; i++) {
                        if (senders[i] && senders[i].track && senders[i].track.kind === 'video') {
                            videoSender = senders[i];
                            break;
                        }
                    }
                }

                return videoSender;
            } catch (e) {
                logger.log('Error getting peer connection video sender:', e);
                return null;
            }
        }

        function isPeerConnectionVideoTrackActive() {
            var peerConnection = service.getPeerConnection();
            var localVideoTrackActive = false;

            try {
                if (peerConnection && peerConnection.getSenders) {
                    //Newer Chrome Spec (64+)
                    var videoSender = service.getPeerConnectionVideoSender();
                    localVideoTrackActive =
                        videoSender && videoSender.track && videoSender.track.readyState === 'live' ? true : false;
                } else if (peerConnection && peerConnection.getLocalStreams) {
                    //Older Chrome spec
                    var localStream = peerConnection.getLocalStreams()[0];

                    if (localStream && localStream.getVideoTracks) {
                        var localVideoTrack = localStream.getVideoTracks()[0];
                        localVideoTrackActive = localVideoTrack && localVideoTrack.readyState === 'live' ? true : false;
                    }
                }
            } catch (e) {
                logger.log('error retrieving peer connection local track', e);
            }

            return localVideoTrackActive;
        }

        function onNewTrack(ev) {
            inActiveConnection = true;
            remoteStream = ev.streams[0];
            $rootScope.$broadcast('established-remote-stream');
        }

        function getRemoteStream() {
            return remoteStream;
        }

        function destroyPeerConnection() {
            if (peerConnection) {
                peerConnection.close();
                inActiveConnection = false;
                peerConnection = null;
                $rootScope.$broadcast('destroyed-remote-stream');
            }
        }

        function updateBandwidthRestriction(sdp, bandwidth) {
            var modifier = 'AS';

            if (adapter.browserDetails.browser === 'firefox') {
                bandwidth = (bandwidth >>> 0) * 1000;
                modifier = 'TIAS';
            }

            if (sdp.indexOf('b=' + modifier + ':') === -1) {
                // insert b= after c= line.
                sdp = sdp.replace(/c=IN (.*)\r\n/, 'c=IN $1\r\nb=' + modifier + ':' + bandwidth + '\r\n');
            } else {
                sdp = sdp.replace(new RegExp('b=' + modifier + ':.*\r\n'), 'b=' + modifier + ':' + bandwidth + '\r\n');
            }

            return sdp;
        }

        function initiatePeerConnectionFlow() {
            peerConnection
                .createOffer(offerOptions)
                .then(function (offer) {
                    peerConnection.setLocalDescription(offer);
                    socketService.send({
                        message: 'offer-created',
                        data: offer
                    });
                })
                .catch(function (err) {
                    logger.error('initiatePeerConnectionFlow', 'createOffer error', err);
                });
        }

        function onNewLocalIceCandidate(ev) {
            socketService.send({
                message: 'new-ice-candidate',
                data: ev.candidate
            });
        }

        function onNewRemoteIceCandidate(evt, data) {
            peerConnection.addIceCandidate(data).catch(function (err) {
                if (err && err.name && err.message) {
                    logger.log(err.name, err.message);
                } else {
                    logger.log('Unable to add ice candidate:', err);
                }
            });
        }

        function onRemoteAnswer(evt, data) {
            peerConnection.setRemoteDescription({
                type: data.type,
                sdp: updateBandwidthRestriction(data.sdp, '1024')
            });
        }

        function onRemoteOffer(evt, data) {
            peerConnection.setRemoteDescription({
                type: data.type,
                sdp: updateBandwidthRestriction(data.sdp, '1024')
            });

            peerConnection.createAnswer().then(function (answer) {
                peerConnection.setLocalDescription(answer);
                socketService.send({
                    message: 'answer-created',
                    data: answer
                });
            });
        }

        function onICEConnectionStateChange(ev) {
            if (peerConnection && peerConnection.iceConnectionState) {
                logger.log('peerConnectionService iceConnectionState changed to:', peerConnection.iceConnectionState);
            }

            if (inActiveConnection === false && peerConnection) {
                if (
                    peerConnection.iceConnectionState == 'connected' ||
                    peerConnection.iceConnectionState == 'completed'
                ) {
                    //if at this point we do not have an activeconnection
                    //newtrack never got called and imples remote did not
                    //provide video
                    inActiveConnection = true;
                    var streams = {
                        local: localStreamManagerService.currentLocalStream,
                        remote: undefined
                    };
                    $rootScope.$broadcast('established-remote-stream', streams);
                }
            }
        }

        function onDestroyPIPPeer() {
            service.destroyPeerConnection();
        }
    }
]);
